var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vertical-bar-chart" },
    [
      _c(
        "bar-chart",
        {
          ref: "barChart",
          attrs: { data: _vm.data, options: _vm.options },
          on: {
            changeData: function($event) {
              return _vm.onChangeData()
            }
          }
        },
        [_vm._v(">")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "bar-legend" }, [
        _c(
          "ul",
          [
            _c(
              "el-checkbox-group",
              {
                staticClass: "flex-level jc-center",
                model: {
                  value: _vm.checkedActivities,
                  callback: function($$v) {
                    _vm.checkedActivities = $$v
                  },
                  expression: "checkedActivities"
                }
              },
              _vm._l(_vm.data.datasets, function(dataset, index) {
                return _c(
                  "el-checkbox",
                  {
                    key: index,
                    staticClass: "mr-6",
                    attrs: { checked: "", label: index },
                    on: {
                      change: function(isChecked) {
                        return _vm.handleFilterLegendChange(isChecked, index)
                      }
                    }
                  },
                  [
                    _c("chip-label", {
                      attrs: {
                        color: dataset.backgroundColor,
                        label: dataset.label,
                        gap: "small"
                      }
                    })
                  ],
                  1
                )
              }),
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }